import axios from "axios";

export async function getLotes({ commit }, payload) {
  try {
    const { data } = await axios.get("/lotes", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getLotesStock({ commit }, payload) {
  try {
    const { data } = await axios.get("/lotes/getLotesStock", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function addLotes({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/add", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function addLotesFortisol({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/addLotesFortisol", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getLogs({ commit }, payload) {
  try {
    const { data } = await axios.get("/lotes/logs", { params: payload });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function setFlaskContaminated({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/update-1-validation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function passValidation1({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/pass-validation-1", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function save2Validation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/update-2-validation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveValidationQPCR({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/update-validation-qpc", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function passValidationQPCR({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/pass-validation-qpc", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function passValidation2({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/pass-validation-2", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function undoValidation2({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-validation-2", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function startIncubating({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/startIncubating", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveIncubatingProgress({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveIncubatingProgress", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveIncubatingQualityProgress({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/saveIncubatingQualityProgress",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function addBagWaste({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/addBagWaste", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function endIncubation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/endIncubation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function endDrying({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/endDrying", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function splitLote({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/splitLote", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function startSifting({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/startSifting", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function deleteLote({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/delete", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishIncubatingQualityProgress({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/finishIncubatingQualityProgress",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveSifrting({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveSifrting", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function endSifting({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/endSifting", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function makeFormulation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/makeFormulation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getFormulations({ commit }, payload) {
  try {
    const { data } = await axios.get("/lotes/getFormulations", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveGrinding({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveGrinding", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishGrinding({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/finishGrinding", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveFermentation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveFermentation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishFermentation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/finishFermentation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveDigestion({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveDigestion", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishDigestion({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/finishDigestion", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function addFormulation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/addFormulation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function addPackaging({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/addPackaging", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function makeUselessLote({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/makeUselessLote", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getHoppers({ commit }, payload) {
  try {
    const { data } = await axios.get("/lotes/getHoppers", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getSummaryBio({ commit }) {
  try {
    const { data } = await axios.get("/lotes/getSummaryBio");

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getSummaryMo({ commit }, payload) {
  try {
    const { data } = await axios.get("/lotes/getSummaryMo", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveDataPreinoculate({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveDataPreinoculate", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveDataPreinoculateValidation({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/saveDataPreinoculateValidation",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishPreinoculate({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/finishPreinoculate", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveValidationCepario({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveValidationCepario", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishValidationCepario({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/finishValidationCepario",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function startInoculate({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/startInoculate", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveInoculate({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveInoculate", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishInoculate({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/finishInoculate", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function startSeed({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/startSeed", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function startSeedFeedable({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/startSeedFeedable", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveSeed({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveSeed", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveSeedFeedable({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveSeedFeedable", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function endSeed({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/endSeed", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function endSeedFeedable({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/endSeedFeedable", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveSeedFinalStage({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveSeedFinalStage", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishSeedFinalStage({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/finishSeedFinalStage", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function goTo3LValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/goTo3LValidation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function save3LValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/save3LValidation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function end3LValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/end3LValidation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function goTo5LValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/goTo5LValidation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function save5LValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/save5LValidation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function end5LValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/end5LValidation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveFermentationReeactorSimple({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/saveFermentationReeactorSimple",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function endFermentationReeactorSimple({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/endFermentationReeactorSimple",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveTimeStartValidation({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/saveTimeStartValidation",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}
export async function finishTimeStartValidation({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/finishTimeStartValidation",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveTimeEndValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveTimeEndValidation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishTimeEndValidation({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/finishTimeEndValidation",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishLote({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/finishLote", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function finishLoteSave({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/finishLoteSave", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function addRefeed({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/addRefeed", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveFeedableData({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/saveFeedableData", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function endFeedable({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/endFeedable", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function endDrumsRegister({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/endDrumsRegister", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getStockByIdentification({ commit }, payload) {
  try {
    const { data } = await axios.get("/lotes/getStockByIdentification", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getFormulation({ commit }, payload) {
  try {
    const { data } = await axios.get("/lotes/getFormulation", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function setSampleDelivery({ commit }, payload) {
  try {
    const { data } = await axios.put("/lotes/setSampleDelivery", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getFormulationValidation({ commit }, payload) {
  try {
    const { data } = await axios.get("/lotes/getFormulationValidation", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function saveValidationData({ commit }, payload) {
  try {
    const { data } = await axios.put("/lotes/saveValidationData", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw e;
  }
}

export async function finshValidationData({ commit }, payload) {
  try {
    const { data } = await axios.put("/lotes/finshValidationData", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw e;
  }
}

export async function addAnalysisValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/addAnalysisValidation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function deleteAnalysisValidation({ commit }, payload) {
  try {
    const { data } = await axios.delete("/lotes/deleteAnalysisValidation", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function setContaminatedFormulation({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/setContaminatedFormulation",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function setPresentationQuality({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/setPresentationQuality", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function removeStock({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/removeStock", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function setPreinoculum({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/setPreinoculum", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function undoPreinoculum({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-preinoculum", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function setInoculum({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/setInoculum", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function undoInoculum({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-inoculum", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function skipSeed({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/skip-seed", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function skip3L({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/skip-3l", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function discardReactivationsUnused({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/discard-reactivations-unused",
      payload
    );

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw (e, message);
  }
}

export async function discardLote({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/discard-lote", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw (e, message);
  }
}

export async function updateStock({ commit }, { params, body }) {
  try {
    const { data } = await axios.put("/lotes/update-stock", body, {
      params: params,
    });
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function updatePLateHistory({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/update-pLate-history", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw (e, message);
  }
}

export async function saveReactorFermentationSterilizationQuality(
  { commit },
  payload
) {
  try {
    const { data } = await axios.post(
      "/lotes/reactor-quality-sterilization",
      payload
    );

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function goToFeedable({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/go-to-feedable", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function saveMRFirstStep({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/save-mr-step", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function saveMRValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/save-mr-validations", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function saveMRPhFlaskFirstStep({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/save-mr-ph-first-step", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function saveFeedablePT({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/save-feedable-pt", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoBatch({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-batch", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoPreinoculate({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-preinoculate", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoStartInoculate({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-start-inoculate", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoStartSeed({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-start-seed", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoFinishSeedFinalStage({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/undo-finish-seed-final-stage",
      payload
    );

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoSaveMRFirstStep({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-save-mr-step", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoEndSeed({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-end-seed", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoFinishInoculate({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-finish-inoculate", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoFinishPreinoculate({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/undo-finish-preinoculate",
      payload
    );

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoEndFermentationReeactorSimple({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/undo-end-fermentation-reeactor-simple",
      payload
    );

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function updateRicePreparation({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/lotes/update-rice-preparation",
      payload
    );

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoRicePreparation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-rice-preparation", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function endInoculationRice({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/end-inoculation-rice", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function startDrying({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/start-drying", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function endSiftingQuality({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/end-sifting-quality", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoEndIncubation({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-end-incubation", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function undoStartDrying({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/undo-start-drying", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function finishFertilizerLote({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/finish-fertilizer", payload);

    if (data.error) {
      throw data.message;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}
